/**
 * =============================================================================
 * blog.js
 * =============================================================================
 * Blog page functionality
 * =============================================================================
 */

var RebuyProductTile = {


  onReady: function(){

     document.addEventListener('rebuy:cart.init', function(event){ 
      console.log('rebuy:cart.init event', event.detail); 
    }); 

    document.addEventListener('rebuy:cart.ready', function(event){ 
      console.log('rebuy:cart.ready event', event.detail); 
    }); 

    document.addEventListener('rebuy:cart.add', function(event){
      MP.Extensions.Cart.fetchAndRenderMinicart(false);
    }); 

    document.addEventListener('rebuy:cart.change', function(event){
      console.log('rebuy:cart.change event', event.detail); 
    }); 

  },

}

export default RebuyProductTile;